
import React from 'react';
import { Card } from '@/components/ui/card';
import SimpleCalculator from '@/components/Calculator/SimpleCalculator';
import SimpleConverter from '@/components/UnitConverter/SimpleConverter';

const HeroSection = () => {
  return (
    <section className="w-full py-12 mb-6">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <Card className="p-5 border-0 shadow-none bg-transparent h-full">
            <SimpleCalculator />
          </Card>
          
          <Card className="p-5 border-0 shadow-none bg-transparent h-full">
            <SimpleConverter />
          </Card>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
